/* eslint-disable */
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(1),
    cursor: "pointer",
    padding: "2px 4px",
    borderRadius: "calc(4px * var(--app-radius-scale, 1))",
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.05)",
    },
  },
  avatar: {
    width: (props) => props.size || 24,
    height: (props) => props.size || 24,
    fontSize: (props) => (props.size ? props.size / 2 : 12),
    lineHeight: "normal",
  },
  name: {
    fontSize: "0.85rem",
    fontWeight: 400,
    color: "inherit",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "150px",
    "&:hover": {
      textDecoration: (props) => (props.hasId ? "underline" : "none"),
    },
  },
  nameSubHeading: {
    fontSize: "0.75rem",
    fontWeight: 500,
    color: "var(--color-text-secondary)",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "150px",
    letterSpacing: "0.01em",
    lineHeight: 1.3,
    "&:hover": {
      textDecoration: (props) => (props.hasId ? "underline" : "none"),
    },
  },
  subHeadingText: {
    display: "flex",
    flexDirection: "column",
  },
  subHeadingDate: {
    fontSize: "0.6875rem",
    color: "var(--color-text-secondary)",
    fontWeight: 400,
    lineHeight: 1.4,
    opacity: 0.8,
  },
}));

const A_UserAvatar = ({ email, size = 24, subHeading = false, date = null, bold = false }) => {
  const allUsers = useSelector((state) => state.allUsers?.users || []);
  const history = useHistory();

  const cleanEmail =
    typeof email === "string" ? email.trim().replace(/^['"]+|['"]+$/g, "").trim() : email;

  const user = allUsers.find(
    (u) =>
      u.email?.toLowerCase() === cleanEmail?.toLowerCase() ||
      u.Email?.toLowerCase() === cleanEmail?.toLowerCase() ||
      u.EmailAddress?.toLowerCase() === cleanEmail?.toLowerCase()
  );

  const userId = user?.id || user?.Id || user?.ID || user?.UserId || user?.userId;
  const hasId = !!userId;
  const classes = useStyles({ size, hasId });

  const fullName = user?.Name || user?.name || user?.fullName || cleanEmail || "Unknown User";
  const image = user?.image;

  const handleNameClick = (e) => {
    if (userId) {
      e.stopPropagation();
      history.push(`/contact/${userId}/1ceb4a1e-462a-4f62-a6ef-5736e415e8a9`);
    }
  };

  return (
    <Tooltip title={cleanEmail || "No email"} arrow placement="top">
      <div className={classes.container}>
        <Avatar src={image} className={classes.avatar} alt={fullName}>
          {!image && fullName ? fullName.charAt(0).toUpperCase() : "?"}
        </Avatar>
        {subHeading ? (
          <div className={classes.subHeadingText}>
            <Typography
              className={classes.nameSubHeading}
              variant="body2"
              onClick={handleNameClick}
              style={{ cursor: userId ? "pointer" : "default" }}
            >
              {fullName}
            </Typography>
            {date && <span className={classes.subHeadingDate}>{date}</span>}
          </div>
        ) : (
          <Typography
            className={classes.name}
            variant="body2"
            onClick={handleNameClick}
            style={{
              cursor: userId ? "pointer" : "default",
              fontWeight: bold ? 700 : undefined,
            }}
          >
            {fullName}
          </Typography>
        )}
      </div>
    </Tooltip>
  );
};

export default A_UserAvatar;
